import {createNamespacedHelpers} from 'vuex'
import { required, minValue, integer } from 'vuelidate/lib/validators'

const { mapActions: mapCartActions, mapGetters: mapCartGetters } = createNamespacedHelpers('Shop/Orders/Cart')

export default {
  data: () => ({
    editMode: false,
    editItem: null,
    playcardProducts: null,
    playcardProductId: null,
    playcardQuantity: null,
    playcardNumber: null,
    isAddingToCart: false,
  }),

  beforeCreate () {
    const validations = {
      playcardProductId: {
        required,
      },
      playcardQuantity: {
        required,
        minValue: minValue(1),
        integer,
      },
      playcardNumber: {
        required,
      }
    }

    Object.assign(this.$options.validations, validations)
  },


  created() {
    this.playcardProducts = window.addiesaas.products.types.playcard_reload
  },


  computed: {
    ...mapCartGetters(['cartItems']),

    playcardProduct() {
      return this.playcardProducts.find(x => x.id == this.playcardProductId)
    },

    addingToCartDisabled() {
      return this.$v.playcardProductId.$error || this.$v.playcardNumber.$error || this.$v.playcardQuantity.$invalid
    },
  },

  methods: {
    ...mapCartActions(['addCartItem', 'removeCartItem']),

    setEditItem(id) {
      if (this.cartItems[id] && this.cartItems[id].type === 'playcard_reload') {
        this.editItem = this.cartItems[id]
        this.editMode = true
        this.playcardProductId = this.editItem.payload.product_id
        this.playcardNumber = this.editItem.payload.options.number
        this.playcardQuantity = this.editItem.payload.count
      }
    },

    getPlaycardCartItem() {
      const item = {
        type: 'playcard_reload',
        total: this.playcardProduct.price,
        count: this.playcardQuantity,
        payload: {
          product_id: this.playcardProductId,
          options: {
            number: this.playcardNumber,
          },
          count: this.playcardQuantity,
        },
        editable: true,
        attributes: {
          product: this.playcardProduct,
        },
      }

      if (this.editMode) {
        item.id = this.editItem.id
      }

      return item
    },

    addPlaycardCartItem(item) {
      this.isAddingToCart = true
      this.addCartItem(item)
    },
  },
}
